import * as React from 'react';

import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import {blue} from '@mui/material/colors';


export default function SelectOptionDialog({
    onClose,
    open,
    selectedValue,
    options
})
{

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>Choose an Option</DialogTitle>
            <List sx={{pt: 0}}>
                {options.map((option) => (
                    <ListItem button onClick={() => handleListItemClick(option.id)} key={option.id}>

                        <ListItemText primary={option.name+" ("+option.id+")"}/>
                    </ListItem>
                ))}


            </List>
        </Dialog>
    );
}

